module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-news-detail"
  }, [_c('content-item', {
    attrs: {
      "title": _vm.$t('news')
    }
  }, [_c('router-link', {
    staticClass: "back-list",
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("\n            返回列表\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "news-header"
  }, [_c('h2', {
    staticClass: "news-header-title"
  }, [_vm._v(_vm._s(_vm.res.title))]), _vm._v(" "), _c('p', {
    staticClass: "news-header-date"
  }, [_vm._v(_vm._s(_vm.res.reporter) + " • " + _vm._s(_vm.res.news_date))])]), _vm._v(" "), _c('div', {
    staticClass: "news-detail-content",
    domProps: {
      "innerHTML": _vm._s(_vm.res.content)
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b7d531ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsDetail.vue
// module id = 389
// module chunks = 6